import { Box, Flex, Text } from "@chakra-ui/react";
import { MdClose } from "react-icons/md";
import * as React from "react";

function FilterCard({ data, remove, isIncludedInReport }) {
  return (
    <Flex
      paddingInline={2}
      height="40px"
      rounded="md"
      bg={isIncludedInReport ? "esg_sub_active" : "white"}
      border="1px solid"
      borderColor="gray.200"
      alignItems="center"
      maxWidth={"115px"}
    >
      <Box marginRight={2} title={`${data.dimensionName}: ${data.item.name}`} maxWidth={"75px"}>
        <Text
          fontSize="xs"
          fontWeight={700}
          color="esg_gray.200"
          opacity="0.75"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          width={"100%"}
        >
          {data.dimensionName}
        </Text>
        <Text
          fontSize="sm"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          width={"100%"}
        >
          {data.item.name}
        </Text>
      </Box>
      <MdClose size="16" cursor="pointer" onClick={remove} />
    </Flex>
  );
}

export default FilterCard;